import Grid from '@material-ui/core/Grid';
import {i18n2} from 'features/i18n/i18n';
import {Field} from 'formik';
import {TextField} from 'formik-material-ui';
import React from 'react';

const EmailContent = ({formikProps}) => {
  return (
    <Grid container spacing={2}>
      <Grid item md={3} xs={12}></Grid>
      <Grid item md={6} xs={12}>
        <Field
          name="emailURL"
          component={TextField}
          label={i18n2._('URL en el email')}
          fullWidth
          variant="outlined"
          size={'small'}
        />
      </Grid>
    </Grid>
  );
};

export default EmailContent;
